const common = {
    methods: {
        disableGroups() {
            this.$nextTick(() => {
                const groups = $('.filter-group');
                groups.each((index, group) => {
                    const inputs = $(group).find(':input');
                    const groupDisabled = $(group).hasClass('is-disabled');
                    inputs.each((index, input) => {
                        if ($(input).parent().hasClass('is-disabled')) {
                            $(input).prop('disabled', true);
                            $(input).prop('checked', false);
                        } else {
                            $(input).prop('disabled', groupDisabled);
                            if (groupDisabled) $(input).prop('checked', false);
                        }
                    });
                });
            });
        },
    },
};

export default common;
